var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_876_64195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1126 8.23642L8.16062 6.77244V3.79027C8.16062 3.49042 7.91825 3.24805 7.6184 3.24805C7.31855 3.24805 7.07617 3.49042 7.07617 3.79027V7.04358C7.07617 7.21437 7.15643 7.37542 7.29306 7.47736L9.46191 9.10401C9.55551 9.1745 9.66953 9.21257 9.7867 9.21246C9.95208 9.21246 10.1147 9.13816 10.221 8.99502C10.4011 8.75587 10.3523 8.41591 10.1126 8.23642Z",
    fill: "#182138",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61914 0C3.75911 0 0.619141 3.13996 0.619141 7C0.619141 10.86 3.75911 14 7.61914 14C11.4792 14 14.6191 10.86 14.6191 7C14.6191 3.13996 11.4792 0 7.61914 0ZM7.61914 12.9156C4.35771 12.9156 1.70357 10.2614 1.70357 7C1.70357 3.73857 4.35771 1.08443 7.61914 1.08443C10.8811 1.08443 13.5347 3.73857 13.5347 7C13.5347 10.2614 10.8806 12.9156 7.61914 12.9156Z",
    fill: "#182138",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_876_64195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.619141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.691136accc61a5ff5bd9ae2f9e3ff7fc.svg";
export { ForwardRef as ReactComponent };